import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Box,
  Typography,
  Radio,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function MobileNumberDialog({ open, handleClose, setting }) {
  console.log("settingsdata", setting);
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      {/* Title with Close Icon */}
      <DialogTitle
        sx={{
          fontWeight: "600",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Which mobile number do you want to use for sharing bulk messages?
        <IconButton onClick={handleClose} sx={{ color: "#01008B" }}>
          <CloseIcon sx={{ fontSize: "25px" }} />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} alignItems="center">
          {/* Elegant Prime Number */}
          <Grid item xs={12} md={5.5}>
            <Box
              sx={{
                border: "1px solid #01008B",
                borderRadius: "8px",
                // p: 2,
              }}
            >
              <Box sx={{ p: 2 }}>
                <Box display="flex" alignItems="center" gap={2} mb={1}>
                  <Radio checked={setting?.usingPersonalWhatsApp === false} />
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#01008B", fontSize: "15px" }}
                  >
                    Elegant Prime Number
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#000" }}
                  >
                    {setting?.companyNumber || "N/A"}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={1} mb={2} p={1}>
                  <Typography sx={{ fontWeight: 500 }}>
                    Your Elegant prime no. Credit Messages:
                  </Typography>
                  <Typography sx={{ fontWeight: 600, color: "#01008B" }}>
                    {setting?.companyMessageCount}
                  </Typography>
                </Box>

                <Button
                  fullWidth
                  sx={{ backgroundColor: "#01008B", fontWeight: 600 }}
                  variant="contained"
                >
                  Recharge Messages
                </Button>
              </Box>
              <Box sx={{ p: 1.5, backgroundColor: "#E3E3FF" }}>
                <Typography
                  sx={{ fontWeight: 600, color: "#01008B", fontSize: "12px" }}
                >
                  The cost for 1 message is 3 Rs.
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* OR Divider */}
          <Grid
            item
            xs={12}
            md={1}
            sx={{
              textAlign: "center",
              fontWeight: 700,
              color: "#01008B",
              fontSize: "24px",
            }}
          >
            or
          </Grid>

          {/* Personal Number */}
          <Grid item xs={12} md={5.5}>
            <Box
              sx={{
                border: "1px solid #01008B",
                borderRadius: "8px",
              }}
            >
              {/* Main Content */}
              <Box sx={{ p: 2 }}>
                {/* Header Row */}
                <Box display="flex" alignItems="center" gap={2} mb={1}>
                  <Radio checked={setting?.usingPersonalWhatsApp === true} />
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 600, color: "#01008B", fontSize: "15px" }}
                  >
                    Your Personal Number
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "green", fontWeight: 600, textAlign: "end" }}
                  >
                    {setting?.personalNumber || "N/A"} <br />
                    {setting?.status || "N/A"}
                  </Typography>
                </Box>

                {/* Verified */}
                {/* <Typography
        variant="body2"
        sx={{ color: "green", fontWeight: 600, textAlign:"end"}}
      >
        Verified
      </Typography> */}

                <Button
                  fullWidth
                  sx={{
                    backgroundColor: "#01008B",
                    fontWeight: 600,
                    textTransform: "none",
                    mb: 1,
                    mt: 1,
                  }}
                  variant="contained"
                >
                  Recharge Messages
                </Button>

                {/* Credit Messages Row */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  gap={1}
                >
                  <Typography sx={{ fontWeight: 500, p: 1 }}>
                    Your Personal Mobile no. Credit Messages:
                  </Typography>
                  <Typography sx={{ fontWeight: 600, color: "#01008B" }}>
                    {setting?.personalMessageCount}
                  </Typography>
                </Box>

                {/* Button */}
              </Box>

              {/* Footer Notes */}
              <Box sx={{ p: 1.5, backgroundColor: "#E3E3FF" }}>
                <Typography
                  variant="caption"
                  display="block"
                  sx={{ fontWeight: 600, color: "#01008B", fontSize: "12px" }}
                >
                  Please make a call or send what's app message on 9209054709
                  (Admin) to purchase plan.
                </Typography>
                <Typography
                  variant="caption"
                  display="block"
                  sx={{ fontWeight: 600, color: "#01008B", fontSize: "13px" }}
                >
                  Note:- To purchase a plan, you must register your number on
                  Meta; verification takes 7–10 days.
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
